import { render, staticRenderFns } from "./OperatingHoursOverrides.vue?vue&type=template&id=61fbe071&"
import script from "./OperatingHoursOverrides.vue?vue&type=script&lang=js&"
export * from "./OperatingHoursOverrides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61fbe071')) {
      api.createRecord('61fbe071', component.options)
    } else {
      api.reload('61fbe071', component.options)
    }
    module.hot.accept("./OperatingHoursOverrides.vue?vue&type=template&id=61fbe071&", function () {
      api.rerender('61fbe071', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/OperatingHoursOverrides/OperatingHoursOverrides.vue"
export default component.exports